import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { NumberBlock, NumberBlockDto, toNumberBlock } from './rufnummer.model';
import { environment } from '../../../../environments/environment';

const PHONESERVICE_BASE = environment.phoneServiceUrl;

@Injectable({ providedIn: 'root' })
export class RufnummerService {
  private readonly http = inject(HttpClient);

  /** Blocks currently linked to the brand. Backend defaults `isLinked=true`. */
  listLinked(brandId: number): Observable<NumberBlock[]> {
    return this.http
      .get<NumberBlockDto[]>(`${PHONESERVICE_BASE}/numberblocks/${brandId}`)
      .pipe(map(list => list.map(toNumberBlock)));
  }

  /** All blocks NOT linked to the brand. Per-brand volume is bounded (~1–3k). */
  listAvailable(brandId: number): Observable<NumberBlock[]> {
    return this.http
      .get<NumberBlockDto[]>(`${PHONESERVICE_BASE}/numberblocks/${brandId}?isLinked=false`)
      .pipe(map(list => list.map(toNumberBlock)));
  }

  /** Idempotent bulk attach. Returns the subset actually inserted. */
  attach(
    brandId: number,
    blocks: readonly Pick<NumberBlock, 'vorwahl' | 'prefix'>[],
  ): Observable<NumberBlock[]> {
    const body = blocks.map(b => ({ vorwahl: b.vorwahl, prefix: b.prefix }));
    return this.http
      .post<NumberBlockDto[]>(`${PHONESERVICE_BASE}/numberblocks/${brandId}`, body)
      .pipe(map(list => list.map(toNumberBlock)));
  }

  /** Idempotent bulk detach. Returns the subset actually deleted. */
  detach(
    brandId: number,
    blocks: readonly Pick<NumberBlock, 'vorwahl' | 'prefix'>[],
  ): Observable<NumberBlock[]> {
    const body = blocks.map(b => ({ vorwahl: b.vorwahl, prefix: b.prefix }));
    return this.http
      .delete<NumberBlockDto[]>(`${PHONESERVICE_BASE}/numberblocks/${brandId}`, { body })
      .pipe(map(list => list.map(toNumberBlock)));
  }
}
